module.exports = __webpack_public_path__ + "static/media/galdinsLose_25_50.555c08fa.png";